import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Tag"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.0273 7.80104L9.54664 3.24033L9.54374 3.23741C8.52282 2.22878 7.78403 1.5 6.5057 1.5H4.46096C3.21898 1.5 2.47147 1.72884 2.03518 2.2419C1.56544 2.79577 1.5 3.67614 1.5 4.54631V6.72536C1.5 7.33754 1.56399 7.7063 1.72687 8.04008C1.89412 8.37969 2.16752 8.67995 2.61399 9.11576L7.66623 14.0671C7.96146 14.3557 8.39047 14.5 8.81804 14.5C9.24415 14.5 9.67171 14.3572 9.96694 14.07L14.0317 10.1025C14.3298 9.81394 14.5 9.39707 14.5 8.95689C14.5014 8.51525 14.3284 8.09401 14.0273 7.80104ZM3.75439 5.39751C3.75439 4.48508 4.49463 3.74318 5.40503 3.74318C6.31542 3.74318 7.05566 4.48508 7.05566 5.39751C7.05566 6.30995 6.31542 7.05184 5.40503 7.05184C4.49463 7.05184 3.75439 6.30995 3.75439 5.39751Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var tag = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { tag as default };
